export default __webpack_public_path__ + "static/media/how-it-works-3.8c22b61c.png";